import { render, staticRenderFns } from "./StudentsSection.vue?vue&type=template&id=e811a33e&scoped=true"
import script from "./StudentsSection.vue?vue&type=script&lang=js"
export * from "./StudentsSection.vue?vue&type=script&lang=js"
import style0 from "./StudentsSection.vue?vue&type=style&index=0&id=e811a33e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_729849d24245ac5da8661ad62b6d24d8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e811a33e",
  null
  
)

export default component.exports